import { akEditorFullPageDefaultFontSize } from '@atlaskit/editor-shared-styles';
/**
 * @param appearance
 * @returns default font size if valid
 */
export function getBaseFontSize(appearance) {
  if (appearance === undefined) {
    return akEditorFullPageDefaultFontSize;
  }
  return !['comment', 'chromeless', 'mobile'].includes(appearance) ? akEditorFullPageDefaultFontSize : undefined;
}